import { render } from "./WelcomeWindow.vue?vue&type=template&id=513d4077&scoped=true"
import script from "./WelcomeWindow.vue?vue&type=script&lang=js"
export * from "./WelcomeWindow.vue?vue&type=script&lang=js"

import "./WelcomeWindow.vue?vue&type=style&index=0&id=513d4077&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513d4077"]])

export default __exports__